module.exports = __webpack_public_path__ + "media/customizations/cannerydistrict/dashboard-87398cacf791151b5ddfd64465e5ae07.jpg";